// extracted by mini-css-extract-plugin
export default {"sign-in":"FJvaAn8YGLWgPT7NYNwe","form":"zcVYaXXgJ0_D6w5aK6Lx"};